// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"e73c55e2","143":"afcf8962","144":"9e79058d","494":"fecc3c54","533":"d1e3c96e","651":"b858aa35","690":"8b9f033f","852":"d7041c28","940":"ec41595d"}[chunkId] + ".chunk.js";
};